import React, { useEffect } from "react";
import { closeModal, Modal, openModal } from "risa-oasis-ui_v2";
import { SwapIcon } from "../../../../shared/svg/swap-icon";
import "./SwapConfirmationDialog.scss";

interface SwapConfirmationDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  step1Title: string;
  step2Title: string;
  loading?: boolean;
}

// Use a constant dialogId
const SWAP_DIALOG_ID = "swap-confirmation-dialog";

const SwapConfirmationDialog: React.FC<SwapConfirmationDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  step1Title,
  step2Title,
  loading = false,
}) => {
  // Open or close the modal when isOpen changes
  useEffect(() => {
    if (isOpen) {
      openModal(SWAP_DIALOG_ID);
    } else {
      closeModal(SWAP_DIALOG_ID);
    }
  }, [isOpen]);

  const handleCancel = () => {
    onClose();
  };

  const handleSave = () => {
    onConfirm();
  };

  return (
    <Modal
      dialogId={SWAP_DIALOG_ID}
      title="Swap Process Steps"
      onCancel={handleCancel}
      onSave={handleSave}
      cancelText="Cancel"
      saveButtonText={loading ? "Swapping..." : "Swap Steps"}
      disableSave={loading}
    >
      <div className="swap-confirmation-content">
        {/* <div className="swap-confirmation-header">
          <SwapIcon width="48" height="48" color="#0056d6" rotation={0} />
          <h3>Confirm Step Swap</h3>
        </div>
 */}
        <div className="swap-steps-preview">
          <div className="swap-step-card">
            <div className="step-number">Step A</div>
            <div className="step-title">{step1Title}</div>
          </div>

          <div className="swap-arrows">
            <SwapIcon width="24" height="24" color="#0056d6" rotation={0} />
          </div>

          <div className="swap-step-card">
            <div className="step-number">Step B</div>
            <div className="step-title">{step2Title}</div>
          </div>
        </div>

        <p className="swap-description">
          Are you sure you want to swap the positions of these two process
          steps?
        </p>

        <div className="swap-warning">
          <div className="warning-icon">⚠️</div>
          <div className="warning-text">
            <strong>Note:</strong> This action will permanently change the order
            of process steps in the configuration. The changes will be saved to
            the database and cannot be undone automatically.
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default SwapConfirmationDialog;
